import isLocalStorageAvailable from './mini/isLocalStorageAvailable';

const cohortHelper = {
    isFilled: function (limitNumberOfDevices, currentNumberOfDevices, maxNumberOfDevices) {
        return limitNumberOfDevices && maxNumberOfDevices > 0 && maxNumberOfDevices === currentNumberOfDevices;
    },

    setCurrentCohort: function (projectId, environment, cohortId) {
        if (isLocalStorageAvailable()) {
            localStorage.setItem(`alan-cohort-${projectId}-${environment}`, cohortId);
        }
    },

    getCurrentCohort: function (projectId, environment) {
        if (isLocalStorageAvailable()) {
            return localStorage.getItem(`alan-cohort-${projectId}-${environment}`);
        }
    }
};

export default cohortHelper;